import { Icon, AlertBox } from '@iwoca/orion';
import { AlertBoxProps } from '@iwoca/orion/lib/components/AlertBox/AlertBox';
import { IconNames } from '@iwoca/orion/lib/components/icon/Icon';
import classNames from 'classnames';
import styles from '../TopUpStatusAlertBox.module.css';

export const TopUpStatusAlertBox = ({
    variant,
    className,
    iconName,
    description,
    iconClassName
}: {
    variant: AlertBoxProps['variant'];
    className?: string;
    iconName: IconNames;
    iconClassName?: string;
    description: React.ReactNode;
}) => {
    return (
        <AlertBox
            data-testid="topup-status-alert-box"
            variant={variant}
            className={classNames(styles.alertBox, className)}
        >
            <Icon
                icon={iconName}
                className={classNames(styles.icon, iconClassName)}
            />
            <div className={styles.descriptionContainer}>
                <p className={styles.description}>{description}</p>
            </div>
        </AlertBox>
    );
};
